type CanFallbackProps = {
  sceneReady?: boolean
}

export function CanFallback({ sceneReady = false }: CanFallbackProps) {
  return (
    <div
      className={`can-fallback${sceneReady ? ' can-fallback--hidden' : ''}`}
      aria-hidden="true"
    >
      <div className="can-fallback__shadow" />
      <div className="can-fallback__body">
        <div className="can-fallback__rim can-fallback__rim--top" />
        <div className="can-fallback__label">
          <span className="can-fallback__flavour">DEEP SPACE FLAVOUR</span>
          <span className="can-fallback__nova">NOVA</span>
          <span className="can-fallback__energy">ENERGY</span>
          <span className="can-fallback__star">✦</span>
          <span className="can-fallback__volume">330 ML // NVA–01</span>
        </div>
        <div className="can-fallback__shine" />
        <div className="can-fallback__rim can-fallback__rim--bottom" />
      </div>
    </div>
  )
}
